import BaseInputComponent from "basecomponents/BaseInputComponent";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { SmallSpinner } from "../components/loaders";
import { InputField, InputSelect, TextArea } from "../components/form";

import { getClientPackages } from "../actions/packageActions";
import {
  createClientArticle,
  updateClientArticle,
  getClientArticleById,
} from "../actions/articleActions";

import { showPopUp, getURLParams } from "../utils/domUtils";

import { IArticle } from "../interfaces/IPackage";
import {
  packages as packageStatus,
  articles as articleStatus,
} from "../config/statusConfig";
class ClientDashboardArticle extends BaseInputComponent {
  state = {
    idArticle: null,
    name: "",
    track_code: "",
    description: "",
    id_package: "0",
    packageOptions: [],
    forUpdate: false,
    status: null,
    errors: {},
  };

  componentDidMount() {
    this.checkIfForUpdate();
    // @ts-ignore
    this.props.getClientPackages({
      available: true,
    });
  }

  static getDerivedStateFromProps(nextProps, currentState) {
    let newState = {
      packageOptions: null,
      errors: null,
      changed: false,
    };
    if (nextProps.errors) {
      newState.errors = nextProps.errors;
      newState.changed = true;
    }
    if (
      nextProps.package?.elements &&
      nextProps.package.elements.length > 0 &&
      currentState.packageOptions.length === 0
    ) {
      newState.packageOptions = nextProps.package.elements.map((e) => ({
        value: e.id,
        label: e.name,
      }));
      if (nextProps?.article?.item?.package) {
        const articlePackage = nextProps.article.item.package;
        const alreadyExists =
          newState.packageOptions.indexOf(
            (p) => p.value === articlePackage.id
          ) >= 0;
        if (!alreadyExists) {
          newState.packageOptions.push({
            value: articlePackage.id,
            label: articlePackage.name,
          });
        }
      }
      newState.changed = true;
    }

    if (!newState.changed) return null;

    Object.keys(newState).forEach((key) => {
      if (newState[key] === null) {
        delete newState[key];
      }
    });

    return newState;
  }

  isLoading(): boolean {
    // @ts-ignore
    return this.props.article.loadingOperation === true;
  }

  canEditPackage(): boolean {
    if (!this.state.forUpdate) {
      return true;
    }
    // @ts-ignore
    const currentArticle: IArticle = this.props.article.item;
    if (!currentArticle) return true;

    const status = [packageStatus.empty, packageStatus.completing, null];
    return status.includes(currentArticle.package_status);
  }

  checkIfForUpdate() {
    const getParams = getURLParams();
    const idArticle = getParams.get("id");
    if (!idArticle) return;

    // @ts-ignore
    this.props.getClientArticleById(idArticle, (success) => {
      if (!success) return;
      this.configArticleFromProps();
      this.setState({
        idArticle,
        forUpdate: true,
      });
    });
  }

  configArticleFromProps = () => {
    // @ts-ignore
    const currentArticle: IArticle = this.props.article.item;
    if (!currentArticle) return;

    this.setState({
      idArticle: currentArticle.id,
      name: currentArticle.name,
      description: currentArticle.description,
      id_package: currentArticle.id_package || "0",
      track_code: currentArticle.track_code,
      status: currentArticle.status,
      forUpdate: true,
    });
  };

  onSaveClick = () => {
    if (this.state.forUpdate) {
      this.onUpdateArticle();
    } else {
      this.onSaveNewArticle();
    }
  };

  onSaveNewArticle() {
    const { name, description, id_package, track_code } = this.state;

    // @ts-ignore
    this.props.createClientArticle(
      {
        name,
        description,
        id_package: id_package !== "0" ? id_package : null,
        track_code,
      },
      (success) => {
        if (success) {
          showPopUp("Articulo creado exitosamente!", "");
          this.configArticleFromProps();
        } else {
          showPopUp(
            "Ocurrio un evento inesperado",
            "Una disculpa por el error, por favor intenta nuevamente en unos momentos"
          );
        }
      }
    );
  }

  onUpdateArticle() {
    const { name, description, id_package, idArticle, track_code } = this.state;

    // @ts-ignore
    this.props.updateClientArticle(
      {
        id: idArticle,
        name,
        description,
        id_package: id_package !== "0" ? id_package : null,
        track_code,
      },
      (success) => {
        if (success) {
          showPopUp("Articulo actualizado exitosamente!", "");
          this.configArticleFromProps();
        } else {
          showPopUp(
            "Ocurrio un evento inesperado",
            "Lamentamos que no se lograra actualizar el articulo, pero por favor intenta nuevamente en unos minutos"
          );
        }
      }
    );
  }

  getForm() {
    const {
      name,
      track_code,
      description,
      id_package,
      packageOptions,
      status,
      errors,
    } = this.state;

    const loading = this.isLoading();
    let disabledPackage = !this.canEditPackage();
    let disabledArticleDetails = status === articleStatus.received;

    if (loading) {
      disabledPackage = true;
      disabledArticleDetails = true;
    }
    return (
      <>
        <div className="form-row">
          <InputField
            id="name"
            label="Nombre"
            name="name"
            value={name}
            onChange={this.onChangeTextInput}
            error={errors}
            disabled={loading}
            extraClass="col-md-6"
          />

          <InputField
            id="track_code"
            label="Tracking"
            name="track_code"
            value={track_code}
            onChange={this.onChangeTextInput}
            error={errors}
            disabled={disabledArticleDetails}
            extraClass="col-md-6"
          />
        </div>

        <InputSelect
          id="id_package"
          name="id_package"
          value={id_package}
          label="Paquete"
          onChange={this.onChangeTextInput}
          error={errors}
          options={packageOptions}
          disabled={disabledPackage}
        />

        <TextArea
          value={description}
          id="description"
          name="description"
          label="Descripci&oacute;n (opcional)"
          disabled={loading}
          onChange={this.onChangeTextInput}
        />

        {loading && <SmallSpinner center={true} />}
      </>
    );
  }

  render() {
    return (
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <div className="card-title">
                {this.state.forUpdate ? "Editar articulo" : "Nuevo articulo"}
              </div>
            </div>
            <div className="card-body">{this.getForm()}</div>
            <div className="card-footer">
              <div
                className="btn btn-outline-primary float-right"
                onClick={this.onSaveClick}
              >
                Guardar
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// @ts-ignore
ClientDashboardArticle.propTypes = {
  article: PropTypes.object.isRequired,
  getClientPackages: PropTypes.func.isRequired,
  createClientArticle: PropTypes.func.isRequired,
  updateClientArticle: PropTypes.func.isRequired,
  getClientArticleById: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  article: state.article,
  package: state.package,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getClientPackages,
  createClientArticle,
  updateClientArticle,
  getClientArticleById,
})(ClientDashboardArticle);
